<!-- Detail.vue -->
<template>
  <div class="detail-container">
    <!-- 头部 -->
    <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="1">首页</el-menu-item>
      <el-submenu index="2">
        <template slot="title">学校概况</template>
        <el-menu-item index="2-1">学校简介</el-menu-item>
        <el-menu-item index="2-2">现任领导</el-menu-item>
        <el-menu-item index="2-3">历任领导</el-menu-item>
        <el-menu-item index="2-3">精神理念</el-menu-item>
        <el-submenu index="2-4">
          <template slot="title">招生就业</template>
          <el-menu-item index="2-4-1">招生信息</el-menu-item>
          <el-menu-item index="2-4-2">就业信息</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-menu-item index="3">新闻网</el-menu-item>
      <el-menu-item index="4"
        ><a href="https://www.ele.me" target="_blank">教学科研</a></el-menu-item
      >
      <el-menu-item index="5">招生就业</el-menu-item>
      <el-menu-item index="6">人才招聘</el-menu-item>
      <el-menu-item index="7">人才队伍</el-menu-item>
    </el-menu>
    <!-- 简介详情 -->
    <el-card class="detail-card">
      <template #header>
        <div class="card-header">
          <h2>{{ universityDetail.SCHOOL_NAME }}</h2>
          <el-button type="primary" @click="$router.go(-1)">返回列表</el-button>
        </div>
      </template>

      <el-descriptions :column="1">
        <el-descriptions-item label="所在省份">
          {{ universityDetail.SZSF }}
        </el-descriptions-item>
        <el-descriptions-item label="学校地址">
          {{ universityDetail.SZSF + universityDetail.SCHOOL_NAME }}
        </el-descriptions-item>
        <el-descriptions-item label="官方网站">
          <el-link :href="universityDetail.website" target="_blank">
            {{ universityDetail.SCHOOL_URL }}
          </el-link>
        </el-descriptions-item>
        <el-descriptions-item label="学校宗旨">
          {{ universityDetail.SCHOOL_MOTTO }}
        </el-descriptions-item>

        <el-descriptions-item label="联系方式">
          {{ universityDetail.SCHOOL_TEL }}
        </el-descriptions-item>

        <el-descriptions-item label="学校目标">
          {{ universityDetail.SCHOOL_TAG }} 
        </el-descriptions-item>

        <el-descriptions-item label="学校简介">
          {{ universityDetail.SCHOOL_TAG }} 
          <p>黄河科技学院创办于1984年，校本部位于河南省郑州市，是经教育部批准成立的一所民办普通本科高校。学校先后成为全国第一所民办普通专科学校、全国第一所建立党委的民办高校、全国第一所民办普通本科高校。2008年，学校顺利通过教育部普通高等学校本科教学工作水平评估，专家组称“震惊、震撼”。2018年，顺利通过教育部本科教学工作审核评估，被专家组赞誉“情怀大、格局大、手笔大、作为大”。2021年，学校获批河南省硕士学位授予重点立项建设单位，入选河南省“十四五”时期重点建设示范性应用技术类型本科高校。学校发展史被联合国教科文组织官员称为“世界教育史上的奇迹”，两次被美国弗吉尼亚大学商学院写进教学案例。 学校连续七年位居武书连中国民办大学综合实力排行榜第一名，连续四年在广州日报全国应用型大学排行榜位居民办高校第一名。学校入选全国首批应用技术大学改革试点战略研究单位、教育部“互联网+中国制造2025”产教融合促进计划建设院校、河南省首批示范性应用技术类型本科院校，获批首批全国创新创业50强高校、首批全国深化创新创业教育改革示范高校、首批全国大学生创业示范园、首批国家级创新创业学院、全国创业孵化园示范基地、全国就业50强高校、全国普通高等学校毕业生预征工作先进集体等。“黄河众创空间”获全国首批众创空间，与大学科技园双双纳入国家级科技企业孵化器管理服务体系。国务院“双创”专题督查等3个调研组先后到校调研，均给予高度评价，新华社通稿报道并刊发在国务院网站。</p>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <!-- 底部 -->
     <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import Footer from '@/components/footer.vue';
export default {
  name: "detail",
  data() {
    return {
      universityDetail: {},
      yxsj: [],
      activeIndex: "1",
      activeIndex2: "1",
    };
  },
  components:{Footer},
  created() {
    // this.getYxsj()
    // this.getDetail()
    this.getDetailData();
  },
  methods: {
    getDetailData() {
      // ---》接口写法
      const id = this.$route.params.id;
      var apiUrl = "/cjfxapi/Records/GetCollegiateById";
      axios
        .get(apiUrl, {
          params: { id },
        })
        .then((res) => {
          console.log(res.data.data[0]);
          this.universityDetail = res.data.data[0];

          // --->本地写法
          //   const id = this.$route.params.id
          //   const university = this.yxsj.find(u => u.school_id === id)
          //   if (university) {
          //     this.universityDetail = university
          //     return
          //   }
          // this.$message.error('院校信息不存在')
          // this.$router.push('/')
        });
    },
    getYxsj() {
      // console.log('院校数据...');
      // console.log(JSON.parse( localStorage.getItem('yxsj') ));
      this.yxsj = JSON.parse(localStorage.getItem("yxsj"));
    },
    getDetail() {
      const id = this.$route.params.id;
      const university = this.yxsj.find((u) => u.school_id === id);
      if (university) {
        this.universityDetail = university;
        return;
      }

      this.$message.error("院校信息不存在");
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.detail-card {
  margin-top: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-descriptions {
  margin-top: 20px;
}

.el-link {
  vertical-align: baseline;
}
</style>
